'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$BankSortCode$() {
  this.aEs = null;
  this.aEt = false;
}
export { $c_Lapp_data_PaymentDetails$package$BankSortCode$ as $c_Lapp_data_PaymentDetails$package$BankSortCode$ };
$p = $c_Lapp_data_PaymentDetails$package$BankSortCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_PaymentDetails$package$BankSortCode$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$BankSortCode$() {
}
export { $h_Lapp_data_PaymentDetails$package$BankSortCode$ as $h_Lapp_data_PaymentDetails$package$BankSortCode$ };
$h_Lapp_data_PaymentDetails$package$BankSortCode$.prototype = $p;
$p.aA = (function() {
  if ((!this.aEt)) {
    this.aEs = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aEt = true;
  }
  return this.aEs;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_PaymentDetails$package$BankSortCode$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$BankSortCode$, "app.data.PaymentDetails$package$BankSortCode$", ({
  EE: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_PaymentDetails$package$BankSortCode$ as $d_Lapp_data_PaymentDetails$package$BankSortCode$ };
var $n_Lapp_data_PaymentDetails$package$BankSortCode$;
function $m_Lapp_data_PaymentDetails$package$BankSortCode$() {
  if ((!$n_Lapp_data_PaymentDetails$package$BankSortCode$)) {
    $n_Lapp_data_PaymentDetails$package$BankSortCode$ = new $c_Lapp_data_PaymentDetails$package$BankSortCode$();
  }
  return $n_Lapp_data_PaymentDetails$package$BankSortCode$;
}
export { $m_Lapp_data_PaymentDetails$package$BankSortCode$ as $m_Lapp_data_PaymentDetails$package$BankSortCode$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-Bank-Sort-Code$.js.map
